// extracted by mini-css-extract-plugin
export default {"EventHeaderImage":"EventHeaderImage-module-b4cbd14f828f7ebca85d"};